import React, { useEffect, useState } from 'react';
import { useForm, useFieldArray } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import { Row, Col, Form, Label, Card, CardBody, FormGroup, Input } from 'reactstrap';

import { countries, organisationType, numberOfEmployees, financialTurnover, industries, detailFields, projectValues, projectAreaSizes } from '../../utils/EntryFormOptions';
import { irelandCounties } from '../../utils/irelandCounties';
import { FaCog } from 'react-icons/fa';
import CategoryQuestionFileUploader from './Modal/CategoryQuestionFileUploader';
import { AiOutlineCiCircle, AiOutlineClose, AiOutlinePlusCircle } from 'react-icons/ai';
import useSiteCookies from './useSiteCookies';
import CollaboratorLogos from '../EntryForms/Collaborator/CollaboratorLogos';
import CustomToast from '../../utils/CustomToast';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageSpinner from 'components/PageSpinner';

const Details = ({ draftStatus, withCategories, categories, country, entryDetails, onNextPage, onData, data, onDraftSubmit, entry_id, categoryQuestions, awardData, category_id, category }) => {

    let history = useHistory();
    const { currentUser, token } = useSiteCookies();

    const location = useLocation();
    var currentPathName = location.pathname;

    const { register, setValue, getValues, handleSubmit, formState: { errors }, reset, watch, control, clearErrors } = useForm({
        defaultValues: {
            text: [{ string: "" }]
        }
    });

    const { fields, append, remove } = useFieldArray({
        name: 'text',
        control,
    });

    const organizationCountry = watch("organization_country");
    const industryValue = watch("industry");

    const [previousCountry, setPreviousCountry] = useState('');

    const [wordCounts, setWordCounts] = useState({});
    const [showFileUploadModal, setShowFileUploadModal] = useState(false);
    const [uploadInstance, setUploadInstance] = useState({});
    const [categoryQuestionsAnswer, setCategoryQuestionsAnswer] = useState([]);

    const [categoryId, setCategoryId] = useState('');
    const [logos, setLogos] = useState([{ url: '' }]);
    const [collabLogoError, setCollabLogoError] = useState(false);

    const [photo1Label, setPhoto1Label] = useState('PHOTO 1');
    const [photo2Label, setPhoto2Label] = useState('PHOTO 2');
    const [entryNameLabel, setEntryNameLabel] = useState('ENTRY NAME');
    const [designPractice, setDesignPractice] = useState("");

    // FOA is 2647 onwards
    const hasProjectFields = ['2516','2517','2518','2519','2520','2521','2522','2526','2528','2529','2530','2531','2537','2538', '1005', '2647', '2648', '2649', '2654', '2655', '2657', '2658', '2659', '2660', '2661', '2662', '2663', '2664', '2665', '2666', '2667', '2671', '2672', '2906', '2907', '2673', '3594', '3619', '3620'];
    const hasCollaborationFields = ['2532'];
    const hasOptionalProjectFields =  ['2513', '2514', '2523', '2524', '2525', '2527', '2532', '2533', '2534', '2535', '2536'];
    const hasPhotoOfPerson = ['2534','2535','2515', '2670', '2669', '2668'];
    const hasClientLogo = ['2533', '2621'];
    const hasProductLogo = ['2513'];

    const candidateUnder5Years = watch('candidate_under_5_years');
    const isSustainableFitOutProject = watch('is_sustainable_fit_out_project')

    const saveDraftSubmit = () => {
        const { text, project_team, ...formValues } = getValues();

        const formattedData = {
            ...formValues,
            additional_content: {
                ...(hasProjectFields.includes(categoryId.toString()) ? {
                    project_value: getValues("project_value"),
                    project_area_size: getValues("project_area_size"),
                    project_completion_date: getValues("project_completion_date"),
                    project_team: text.map(item => item.string) || [],
                    company_design_practice: getValues("company_design_practice"),
                    company_permission: getValues("company_permission")
                } : {}),
                ...(hasCollaborationFields.includes(categoryId.toString()) ? {
                    project_team: text.map(item => item.string) || []
                } : {})
            },
            ...(hasCollaborationFields.includes(categoryId.toString()) && {
                entry_collaborator_logos: logos || ''
            }),
        };

        onDraftSubmit(formattedData);
    };

    const handleCompanyDesignPractice = (e) => {
        const {value} = e.target;
        if (value === "Yes") {
            setValue("company_permission", "Yes");
            setDesignPractice("Yes");
        } else {
            setValue("company_permission", ""); // Reset if "No" is selected
            setDesignPractice("No");
        }
    }

    const nextPage = (e) => {
        if (designPractice && designPractice == "No" && e.company_permission && e.company_permission != "Yes") {
            toast.warning(
                "You cannot proceed without the permission of the project's fit out design practice!",
                {
                position: 'top-right',
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                },
            );

            return;
        }
        if (hasCollaborationFields.includes(categoryId.toString()) && logos.some(x => x.name === '')) {
            CustomToast.warning('Please fill in or remove the empty collaboration logo.');
            setCollabLogoError(true);
            return;
        }        

        const { text, project_team, ...formValues } = e;

        const formattedData = {
            ...formValues,
            additional_content: {
                ...(hasProjectFields.includes(categoryId.toString()) ? {
                    project_value: e.project_value,
                    project_area_size: e.project_area_size,
                    project_completion_date: e.project_completion_date,
                    project_team: text.map(item => item.string) || [],
                    company_design_practice: e.company_design_practice,
                    company_permission: e.company_permission
                } : {}),
                ...(hasCollaborationFields.includes(categoryId.toString()) ? {
                    project_team: text.map(item => item.string) || []
                } : {})
            },
            ...(hasCollaborationFields.includes(categoryId.toString()) && {
                entry_collaborator_logos: logos || ''
            }),
        };        

        onNextPage();
        onData({ details: formattedData });
    };

    const uploadFiles = (instance, id) => {
        setUploadInstance({instance, id});
        setShowFileUploadModal(true);
    };

    const handleChangeFile = (item) => {
        setValue(`${uploadInstance.id}`, item.target.value);
        setShowFileUploadModal(false);
    };

    useEffect(() => {
        if (category_id) {
            setCategoryId(category_id);
        }
    }, [category_id])

    useEffect(() => {
        if (country && !entry_id) {
            if (country === 'Ireland') {
                setValue('organization_country', country);
            }
        }
    }, [country]);

    useEffect(() => {
        if (entry_id) {
            setPreviousCountry(data.organization_country);
            detailFields.map((field) => {
                setValue(field, data[field]);
            });
        }

        if (data) {
            const transformedData = {
                ...data,
                ...(data.additional_content || {}),
                text: data.additional_content && data.additional_content.project_team ? data.additional_content.project_team.map(member => ({ string: member })) : [{ string: "" }],
                ...(!entry_id && country === 'Ireland' && { organization_country: 'Ireland' })
            };

            if (data.additional_content && data.additional_content.project_team) {
                const formattedText = data.additional_content.project_team.map(member => ({ string: member }));
                
                remove();
                append(formattedText);
            }

            setCategoryQuestionsAnswer(data.category_question_answers_1);
            if (Array.isArray(data.category_question_answers_1)) {
                data.category_question_answers_1.forEach(({ category_question_id, content }) => {
                    transformedData[`category_question_id-${category_question_id}`] = content;
                });
            }

            if (data.additional_content && data.additional_content.company_design_practice) {
                setDesignPractice(data.additional_content.company_design_practice);
            }
    
            reset(transformedData);

            setLogos(data.entry_collaborator_logos || [{ url: '' }]);
        }
    }, [reset, data]);

    useEffect(() => {
    if (category_id && category_id != "") {
        if (hasPhotoOfPerson.includes(String(category_id))) {
        if (category_id == 2534 || category_id == 2670) {
            setEntryNameLabel("DESIGNER NAME");
        } else if (category_id == 2535 || category_id == 2669) {
            setEntryNameLabel("RISING STAR NAME");
        } else if (category_id == 2515 || category_id == 2668) {
            setEntryNameLabel("PROJECT MANAGER NAME");
        }
        setPhoto1Label("IMAGE OF PERSON 1");
        setPhoto2Label("IMAGE OF PERSON 2");
        }
        if (hasClientLogo.includes(String(category_id))) {
            setEntryNameLabel("CLIENT NAME");
            setPhoto1Label("CLIENT ORGANISATION LOGO 1");
            setPhoto2Label("CLIENT ORGANISATION LOGO 2");
        }
        if (hasProductLogo.includes(String(category_id))) {
            setPhoto1Label("IMAGE OF PRODUCT 1");
            setPhoto2Label("IMAGE OF PRODUCT 2");
        }
    }

    console.log(category_id);
    }, [category_id]);

    const handleAddCollabLogos = () => {
        let list = logos;
        list = [...list, { url: '', name: '' }];
        setLogos(() => list);
    }
    
    const handleDeleteCollabLogos = (index) => {
        let list = logos;
        list.splice(index, 1);
    
        setLogos(() => [...list]);
    }
    
    const handleChangeCollabLogos = (e, index) => {
        const { name, url } = e;
        let list = logos;
        list[index] = { name: name, url: url };
    
        setLogos(() => [...list]);
        setCollabLogoError(false);
    }

    let disableValidation = false;
    if (currentPathName == "/entry-form/preview") {
        disableValidation = true;
    }

    return (
        <Col lg="12" className="px-0">
            <Form onSubmit={handleSubmit(nextPage)}>
                {category && category.group ?
                    <Row>
                        {category.group == 'Rising Star' ?
                            <>
                                <Col lg="12" className="mb-0">
                                    <Card className={(!entry_id && (candidateUnder5Years == null || candidateUnder5Years == 0)) || (entry_id && candidateUnder5Years != null) ? "" : "mb-3"}>
                                        <CardBody>
                                            <Row>
                                                <Col lg="12" className="mb-0">
                                                    <Label for="candidate_under_5_years" className="award-subheader font-weight-bold mb-2" style={{ display: 'block' }}>
                                                        Does the candidate have less than 5 years experiences?
                                                        <span className="asterisk_red">*</span>
                                                    </Label>
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            {...register("candidate_under_5_years", {
                                                            })}
                                                            disabled={!!entry_id}
                                                            value="1"
                                                            checked={entry_id ? true : candidateUnder5Years == 1}
                                                        />{" "}
                                                        Yes
                                                    </label>
                                                    <label className="ml-3">
                                                        <input
                                                            type="radio"
                                                            {...register("candidate_under_5_years", { 
                                                            })}
                                                            disabled={!!entry_id}
                                                            value="0"
                                                            checked={entry_id ? false : candidateUnder5Years == 0}
                                                        />{" "}
                                                        No
                                                    </label>
                                                </Col>
                                                {candidateUnder5Years && candidateUnder5Years == 0 ? (
                                                    <Col lg="12">
                                                        <p className="invalid-feedback d-block">The candidate must have less than 5 years experiences</p>
                                                    </Col>
                                                ) : null }
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </>
                        : category.group == 'Sustainable Fit Out Project' ?
                            <>
                                <Col lg="12" className="mb-0">
                                    <Card className={(!entry_id && (isSustainableFitOutProject == null || isSustainableFitOutProject == 0)) || (entry_id && isSustainableFitOutProject != null) ? "" : "mb-3"}>
                                        <CardBody>
                                            <Row>
                                                <Col lg="12" className="mb-0">
                                                    <Label for="is_sustainable_fit_out_project" className="award-subheader font-weight-bold mb-2" style={{ display: 'block' }}>
                                                        Is your company the fit out design practice for this project?
                                                        <span className="asterisk_red">*</span>
                                                    </Label>
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            {...register("is_sustainable_fit_out_project", {
                                                            })}
                                                            disabled={!!entry_id}
                                                            value="1"
                                                            checked={entry_id ? true : isSustainableFitOutProject == 1}
                                                        />{" "}
                                                        Yes
                                                    </label>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </>
                        : null }
                        {(category.group == 'Rising Star' && candidateUnder5Years == 1) || (category.group == 'Sustainable Fit Out Project' && isSustainableFitOutProject == 1) || (category.group !== 'Rising Star' && category.group !== 'Sustainable Fit Out Project') || entry_id ?
                            <Col lg="12">
                                <Card className="mb-3">
                                    <CardBody>
                                        {withCategories && (
                                            <>
                                                <Label className="award-subheader font-weight-bold mb-2">
                                                    CATEGORY
                                                    <span className="asterisk_red">
                                                        *
                                                    </span>
                                                </Label>
                                                <select
                                                    {...register("category_id", disableValidation ? {} : { required: "Category is required" })}
                                                    className={`form-control ${errors.category_id ? "form-invalid mb-0" : "mb-3"}`}
                                                >
                                                    <option disabled>
                                                        Please select
                                                    </option>
                                                    {categories.map(
                                                        ({ id, name }, index) => (
                                                            <>
                                                                <option
                                                                    key={index}
                                                                    value={id}
                                                                >
                                                                    {name}
                                                                </option>
                                                            </>
                                                        ),
                                                    )}
                                                </select>
                                                {errors.category_id ? <p role="alert" className="invalid-feedback">{errors.category_id.message}</p> : null}
                                            </>
                                        )}

                                        <>
                                            <Label className="award-subheader font-weight-bold mb-2 text-uppercase">
                                                {hasProjectFields.includes(categoryId.toString()) ? 'PROJECT NAME' : entryNameLabel }
                                                <span className="asterisk_red">*</span>
                                            </Label>
                                            {/* <p className="form-p mb-2">
                                                E.g. project name, initiative, person,
                                                technology. It should be something that
                                                you are happy to be made public, if
                                                shortlisted. Word limits apply, so please
                                                keep your answer short.
                                            </p> */}
                                            <input
                                                {...register("name", disableValidation ? {} : { required: entryNameLabel+" is required" })}
                                                type="text"
                                                maxLength={240}
                                                className={`form-control ${errors.name ? "form-invalid mb-0" : "mb-3"}`}
                                            />
                                            {errors.name ? <p role="alert" className="invalid-feedback">{errors.name.message}</p> : null}
                                        </>

                                        {hasProjectFields.includes(categoryId.toString()) && (
                                            <>
                                                <Row>
                                                    <Col lg="12" className="mb-3">
                                                        <Label className="award-subheader font-weight-bold mb-2">
                                                            PROJECT VALUE
                                                            <span className="asterisk_red">*</span>
                                                        </Label>
                                                        <p className="form-p mb-2">
                                                            Please clarify the overall budget for
                                                            the entire construction project.
                                                        </p>
                                                        <select
                                                            {...register("project_value", disableValidation ? {} : { required: "Project value is required" })}
                                                            className={`form-control ${errors.project_value ? "form-invalid mb-0" : "mb-0"}`}
                                                        >
                                                            <option value="">
                                                                Please select
                                                            </option>
                                                            {projectValues(awardData.award_type.currency_sign).map((item, index) => {
                                                                return (
                                                                    <option key={index} value={item}>
                                                                        {item}
                                                                    </option>
                                                                )
                                                            })}
                                                        </select>
                                                        {errors.project_value ? <p role="alert" className="invalid-feedback mb-0">{errors.project_value.message}</p> : null}
                                                    </Col>
                            
                                                    <Col lg="12" className="mb-3">
                                                        <Label className="award-subheader font-weight-bold mb-2">
                                                            PROJECT AREA SIZE
                                                            <span className="asterisk_red">*</span>
                                                        </Label>
                                                        <p className="form-p mb-2">
                                                            Please clarify the size of the
                                                            building (in square feet).
                                                        </p>
                                                        <select
                                                            {...register("project_area_size", disableValidation ? {} : { required: "Project area size is required" })}
                                                            className={`form-control ${errors.project_area_size ? "form-invalid mb-0" : "mb-0"}`}
                                                        >
                                                            <option value="">
                                                                Please select
                                                            </option>
                                                            {projectAreaSizes.map((item, index) => {
                                                                return (
                                                                    <option key={index} value={item}>
                                                                        {item}
                                                                    </option>
                                                                )
                                                            })}
                                                        </select>
                                                        {errors.project_area_size ? <p role="alert" className="invalid-feedback mb-0">{errors.project_area_size.message}</p> : null}
                                                    </Col>
                            
                                                    <Col lg="12" className="mb-3">
                                                        <Label className="award-subheader font-weight-bold mb-2">
                                                            PROJECT COMPLETION DATE
                                                            <span className="asterisk_red">*</span>
                                                        </Label>
                                                        <Input
                                                            type="date"
                                                            {...register("project_completion_date", disableValidation ? {} : { required: "Project completion date is required" })}
                                                            className={`form-control ${errors.project_completion_date ? "form-invalid mb-0" : "mb-0"}`}
                                                            value={getValues().project_completion_date}
                                                            onChange={(e) => {
                                                                setValue("project_completion_date", e.target.value);
                                                                clearErrors("project_completion_date");
                                                            }}
                                                        />
                                                        {errors.project_completion_date ? <p role="alert" className="invalid-feedback mb-0">{errors.project_completion_date.message}</p> : null}
                                                    </Col>
                            
                                                    <Col lg="12" className="mb-3">
                                                        <Label className="award-subheader font-weight-bold mb-2">
                                                            PROJECT TEAMS
                                                            <span className="asterisk_red">*</span>
                                                        </Label>
                                                        <p className="form-p mb-2">
                                                            Please include a full list of the teams that were involved in the project, i.e. collaborators, clients, suppliers, project managers, etc.
                                                        </p>
                                                        {fields.map((field, index) => (
                                                            <Row key={field.id}>
                                                                <Col lg={`${fields.length > 1 ? '11' : '12'}`} className="mb-2">
                                                                    <div>
                                                                        <input
                                                                            type='text'
                                                                            className={`form-control ${errors["text"] && errors["text"][index] && errors["text"][index].string ? 'is-invalid mb-0' : 'mb-0'}`}
                                                                            {...register(`text.${index}.string`, disableValidation ? {} : {
                                                                                required: "This is required",
                                                                            })}
                                                                        />
                                                                        {errors["text"] && errors["text"][index] && errors["text"][index].string && (
                                                                            <p role="alert" className="invalid-feedback mb-0">
                                                                                {errors["text"][index].string.message}
                                                                            </p>
                                                                        )}
                                                                    </div>
                                                                </Col>
                                                                <Col lg='1' className={`${fields.length > 1 ? 'd-block' : 'd-none'}`}>
                                                                    <AiOutlineClose className='delete-stakeholders mt-2 cursor-pointer' onClick={() => remove(index)} />
                                                                </Col>
                                                            </Row>
                                                        ))}
                                                        <span className="me-2 d-flex align-items-center cursor-pointer" onClick={() => append({string: ''})}>
                                                            <AiOutlinePlusCircle className='artwork-add-icon' />&nbsp;&nbsp; Add More
                                                        </span>
                                                    </Col>
                            
                                                    <Col lg="12">
                                                        <FormGroup>
                                                            <Label for="company_design_practice" className="award-subheader font-weight-bold mb-2">
                                                                Is your company the fit out design practice for this project?
                                                                <span className="asterisk_red">*</span>
                                                            </Label>
                                                            <br />
                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    {...register("company_design_practice", disableValidation ? {} : { required: "This field is required" })}
                                                                    value="Yes"
                                                                    onClick={handleCompanyDesignPractice}
                                                                />{" "}
                                                                Yes
                                                            </label>
                                                            <label className="ml-2">
                                                                <input
                                                                    type="radio"
                                                                    {...register("company_design_practice", disableValidation ? {} : { required: "This field is required" })}
                                                                    value="No"
                                                                    onClick={handleCompanyDesignPractice}
                                                                />{" "}
                                                                No
                                                            </label>
                                                            {errors.company_design_practice && (
                                                                <p className="invalid-feedback d-block">{errors.company_design_practice.message}</p>
                                                            )}
                                                        </FormGroup>
                                                    </Col>
                                                    {designPractice == "No" ?
                                                        <Col lg="12">
                                                            <FormGroup>
                                                                <Label for="company_permission" className="award-subheader font-weight-bold mb-2">
                                                                    Do you have permission from the project's fit out design practice to submit this project?
                                                                    <span className="asterisk_red">*</span>
                                                                </Label>
                                                                <p className="form-p mb-2">
                                                                    You need the permission of the project's main fit out design practice before submitting as we can only accept 1 submission per project.
                                                                </p>
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        {...register("company_permission", disableValidation ? {} : { required: "This field is required" })}
                                                                        value="Yes"
                                                                    />{" "}
                                                                    Yes
                                                                </label>
                                                                <label className="ml-2">
                                                                    <input
                                                                        type="radio"
                                                                        {...register("company_permission", disableValidation ? {} : { required: "This field is required" })}
                                                                        value="No"
                                                                    />{" "}
                                                                    No
                                                                </label>
                                                                {errors.company_permission && (
                                                                    <p className="invalid-feedback d-block">{errors.company_permission.message}</p>
                                                                )}

                                                                {hasProjectFields.includes(categoryId.toString()) && (
                                                                    <p className="small" style={{ fontStyle: "italic" }}>
                                                                        <strong>You cannot proceed without the permission of the project's fit out design practice.</strong>
                                                                    </p>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        :
                                                        null
                                                    }
                                                </Row>
                                            </>
                                        )}

                                        {hasCollaborationFields.includes(categoryId.toString()) &&
                                            <>
                                                <Row>
                                                    <Col lg="12" className="mb-3">
                                                        <Label className="award-subheader font-weight-bold mb-2">
                                                            COLLABORATORS
                                                            <span className="asterisk_red">*</span>
                                                        </Label>
                                                        <p className="form-p mb-2">
                                                            Please include a full list of the teams that were involved in the project, i.e. collaborators, clients, suppliers, project managers, etc.
                                                        </p>
                                                        {fields.map((field, index) => (
                                                            <Row key={field.id}>
                                                                <Col lg={`${fields.length > 1 ? '11' : '12'}`} className="mb-2">
                                                                    <div>
                                                                        <input
                                                                            type='text'
                                                                            className={`form-control ${errors["text"] && errors["text"][index] && errors["text"][index].string ? 'is-invalid mb-0' : 'mb-0'}`}
                                                                            {...register(`text.${index}.string`, disableValidation ? {} : {
                                                                                required: "This is required",
                                                                            })}
                                                                        />
                                                                        {errors["text"] && errors["text"][index] && errors["text"][index].string && (
                                                                            <p role="alert" className="invalid-feedback mb-0">
                                                                                {errors["text"][index].string.message}
                                                                            </p>
                                                                        )}
                                                                    </div>
                                                                </Col>
                                                                <Col lg='1' className={`${fields.length > 1 ? 'd-block' : 'd-none'}`}>
                                                                    <AiOutlineClose className='delete-stakeholders mt-2 cursor-pointer' onClick={() => remove(index)} />
                                                                </Col>
                                                            </Row>
                                                        ))}
                                                        <span className="me-2 d-flex align-items-center cursor-pointer" onClick={() => append({string: ''})}>
                                                            <AiOutlinePlusCircle className='artwork-add-icon' />&nbsp;&nbsp; Add More
                                                        </span>
                                                    </Col>

                                                    <Col lg="12" className="mb-3">
                                                        <FormGroup>
                                                            <Label for="name" className="award-subheader font-weight-bold mb-2">COLLABORATOR LOGOS <span className="asterisk_red">*</span></Label>
                                                            {logos.map(({ name, url }, index) => (
                                                                <div className={`d-flex align-items-center ${logos.length - 1 === index ? 'mb-2' : 'mb-2'}`}>
                                                                <div style={{ display: 'inline', width: `${logos.length > 1 ? '95%' : '100%'}` }}>
                                                                    <CollaboratorLogos
                                                                        logo={url}
                                                                        isError={collabLogoError}
                                                                        name={url !== undefined && url !== null && url !== '' ? url.split('/').slice(-1) : ''}
                                                                        onSave={(e) => handleChangeCollabLogos(e, index)}
                                                                        currentUser={currentUser}
                                                                        token={token}
                                                                    />
                                                                </div>
                                                                {logos.length > 1 && (
                                                                    <AiOutlineClose
                                                                    className='delete-stakeholders ml-2 cursor-pointer'
                                                                    onClick={() => handleDeleteCollabLogos(index)}
                                                                    />
                                                                )}
                                                                </div>
                                                            ))}
                                                            <p className='mb-2'>
                                                                <span onClick={handleAddCollabLogos} style={{ cursor: 'pointer' }}>
                                                                <AiOutlinePlusCircle
                                                                    className='artwork-add-icon' />  Add more
                                                                </span>
                                                            </p>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </>
                                        }

                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                ENTRANT NAME
                                                <span className="asterisk_red">*</span>
                                            </Label>
                                            <Row>
                                                <Col md="6" className="mb-0 pr-1">
                                                    <input
                                                        {...register("first_name", disableValidation ? {} : { required: "First Name is required" })}
                                                        type="text"
                                                        maxLength={40}
                                                        className={`form-control ${errors.first_name ? "form-invalid mb-0" : "mb-3"}`}
                                                        placeholder="First Name"
                                                    />
                                                    {errors.first_name ? <p role="alert" className="invalid-feedback">{errors.first_name.message}</p> : null}
                                                </Col>
                                                <Col md="6" className="mb-0 pl-1">
                                                    <input
                                                        {...register("last_name", disableValidation ? {} : { required: "Last Name is required" })}
                                                        type="text"
                                                        maxLength={40}
                                                        className={`form-control ${errors.last_name ? "form-invalid mb-0" : "mb-3"}`}
                                                        placeholder="Last Name"
                                                    />
                                                    {errors.last_name ? <p role="alert" className="invalid-feedback">{errors.last_name.message}</p> : null}
                                                </Col>
                                            </Row>
                                        </>

                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                JOB POSITION
                                                <span className="asterisk_red">*</span>
                                            </Label>
                                            <input
                                                {...register("job_position", disableValidation ? {} : { required: "Job Position is required" })}
                                                type="text"
                                                maxLength={40}
                                                className={`form-control ${errors.job_position ? "form-invalid mb-0" : "mb-3"}`}
                                            />
                                            {errors.job_position ? <p role="alert" className="invalid-feedback">{errors.job_position.message}</p> : null}
                                        </>
                                    </CardBody>
                                </Card>
                                


                                <Card className="mb-3">
                                    <CardBody>
                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                ORGANISATION NAME
                                                <span className="asterisk_red">*</span>
                                            </Label>
                                            <p className="form-p mb-2">
                                                Please specify which organisation name we
                                                should use when crediting your entry.
                                            </p>
                                            <input
                                                {...register("organization_name", disableValidation ? {} : { required: "Organisation Name is required" })}
                                                type="text"
                                                maxLength={40}
                                                className={`form-control ${errors.organization_name ? "form-invalid mb-0" : "mb-3"}`}
                                            />
                                            {errors.organization_name ? <p role="alert" className="invalid-feedback">{errors.organization_name.message}</p> : null}
                                        </>

                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                ORGANISATION ADDRESS
                                                <span className="asterisk_red">*</span>
                                            </Label>
                                            <input
                                                {...register("organization_address_line_1", disableValidation ? {} : { required: "Address is required" })}
                                                type="text"
                                                placeholder="Address"
                                                maxLength={40}
                                                className={`form-control ${errors.organization_address_line_1 ? "form-invalid mb-0" : "mb-2"}`}
                                            />
                                            {errors.organization_address_line_1 ? <p role="alert" className="invalid-feedback">{errors.organization_address_line_1.message}</p> : null}
                                            <input
                                                {...register("organization_address_line_2")}
                                                type="text"
                                                placeholder="Address Line 2"
                                                maxLength={40}
                                                className={`form-control ${errors.organization_address_line_2 ? "form-invalid mb-0" : "mb-2"}`}
                                            />
                                            <Row>
                                                <Col md='6' className='mb-0 pr-1'>
                                                    <select
                                                        {...register("organization_country", disableValidation ? {} : {
                                                            // required: "Country is required",
                                                            required: country === 'Ireland' ? false : "Country is required",
                                                            onChange: (e) => {
                                                                setValue("organization_province", "");
                                                            }
                                                        })}
                                                        className={`form-control ${errors.organization_country ? "form-invalid mb-0" : "mb-2"}`}
                                                        disabled={(!entry_id && country === 'Ireland') || (entry_id && country === 'Ireland' && previousCountry === 'Ireland') ? true : false}
                                                    >
                                                        <option value="">
                                                            Select country
                                                        </option>
                                                        {countries.map(
                                                            (country, index) => (
                                                                <>
                                                                    <option
                                                                        key={index}
                                                                        value={country}
                                                                    >
                                                                        {country}
                                                                    </option>
                                                                </>
                                                            ),
                                                        )}
                                                    </select>
                                                    {errors.organization_country ? <p role="alert" className="invalid-feedback">{errors.organization_country.message}</p> : null}
                                                </Col>
                                                <Col md='6' className='mb-0 pl-1'>
                                                    <input
                                                        {...register("organization_city", disableValidation ? {} : { required: "City is required" })}
                                                        type="text"
                                                        maxLength={40}
                                                        className={`form-control ${errors.organization_city ? "form-invalid mb-0" : "mb-2"}`}
                                                        placeholder="City"
                                                    />
                                                    {errors.organization_city ? <p role="alert" className="invalid-feedback">{errors.organization_city.message}</p> : null}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md="6" className="pr-1 mb-0">
                                                    {organizationCountry === 'Ireland' ? (
                                                        <select
                                                            {...register('organization_province', disableValidation ? {} : { required: 'Province is required' })}
                                                            className={`form-control ${errors.organization_province ? 'form-invalid mb-0' : 'mb-2'}`}
                                                        >
                                                            <option value="">Select County</option>
                                                            {irelandCounties.map((item, index) => (
                                                                <option key={index} value={item}>
                                                                    {item}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    ) : (
                                                        <input
                                                            {...register('organization_province', disableValidation ? {} : { required: 'Province is required' })}
                                                            type="text"
                                                            placeholder="Province/State"
                                                            maxLength={40}
                                                            className={`form-control ${errors.organization_province ? 'form-invalid mb-0' : 'mb-2'}`}
                                                        />
                                                    )}
                                                    {errors.organization_province ? <p role="alert" className="invalid-feedback">{errors.organization_province.message}</p> : null}
                                                </Col>
                                                <Col md="6" className="mb-0 pl-1">
                                                    <input
                                                        {...register("organization_zip", disableValidation ? {} : { required: `${(country === 'Ireland') || organizationCountry === 'Ireland' ? 'Eircode' : 'Post Code'} is required` })}
                                                        type="text"
                                                        placeholder={`${(country === 'Ireland') || organizationCountry === 'Ireland' ? 'Eircode' : 'Post Code'}`}
                                                        maxLength={40}
                                                        className={`form-control ${errors.organization_zip ? "form-invalid mb-0" : "mb-2"}`}
                                                    />
                                                    {errors.organization_zip ? <p role="alert" className="invalid-feedback">{errors.organization_zip.message}</p> : null}
                                                </Col>
                                            </Row>
                                            {((organizationCountry !== 'Ireland') || (previousCountry !== 'Ireland' && entry_id)) && (
                                                <Row>
                                                    <Col md="12" className="mb-0">
                                                        <select
                                                            {...register("organization_address_type", disableValidation ? {} : { required: "Address Type is required" })}
                                                            className={`form-control ${errors.organization_address_type ? "form-invalid mb-0" : "mb-2"}`}
                                                        >
                                                            <option value="">
                                                                Select Organisation Address Type
                                                            </option>
                                                            {organisationType.map(
                                                                (type, index) => (
                                                                    <>
                                                                        <option
                                                                            key={index}
                                                                            value={type}
                                                                        >
                                                                            {type}
                                                                        </option>
                                                                    </>
                                                                ),
                                                            )}
                                                        </select>
                                                        {errors.organization_address_type ? <p role="alert" className="invalid-feedback">{errors.organization_address_type.message}</p> : null}
                                                    </Col>
                                                </Row>
                                            )}
                                            <Row className="mb-2">
                                                <Col md="6" className="pr-1">
                                                    <input
                                                        {...register("organization_email", disableValidation ? {} : { required: "Email is required" })}
                                                        type="email"
                                                        placeholder="Email"
                                                        maxLength={80}
                                                        className={`form-control ${errors.organization_email ? "form-invalid mb-0" : "mb-2"}`}
                                                    />
                                                    {errors.organization_email ? <p role="alert" className="invalid-feedback">{errors.organization_email.message}</p> : null}
                                                </Col>
                                                <Col md="6" className="pl-1">
                                                    <input
                                                        {...register("organization_phone", disableValidation ? {} : { required: "Phone is required" })}
                                                        type="tel"
                                                        placeholder="Phone"
                                                        maxLength={150}
                                                        className={`form-control ${errors.organization_phone ? "form-invalid mb-0" : "mb-2"}`}
                                                    />
                                                    {errors.organization_phone ? <p role="alert" className="invalid-feedback">{errors.organization_phone.message}</p> : null}
                                                </Col>
                                            </Row>
                                        </>
                                    </CardBody>
                                </Card>

                                <Card className="mb-3">
                                    <CardBody>
                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                ENTRY SUMMARY FOR OUR PRINT MATERIALS (50
                                                WORDS/500 CHARACTERS MAX)
                                                <span className="asterisk_red">*</span>
                                            </Label>
                                            <p className="form-p mb-2">
                                                Written in 3rd person, please state the
                                                main points and results of your entry.
                                                THIS MAY BE INCLUDED IN THE AWARDS
                                                PROGRAMME so only include information you
                                                are happy to share.
                                            </p>
                                            <input
                                                {...register("entry_summary", disableValidation ? {} : {
                                                    required: "Entry Summary is required",
                                                    validate: value => {
                                                        const wordCount = value.trim().split(/\s+/).length;
                                                        return wordCount <= 50 || "Entry Summary must be 50 words or less";
                                                    }
                                                })}
                                                type="textarea"
                                                className={`form-control ${errors.entry_summary ? "form-invalid mb-0" : "mb-3"}`}
                                            />
                                            {errors.entry_summary ? <p role="alert" className="invalid-feedback">{errors.entry_summary.message}</p> : null}
                                        </>
                                    </CardBody>
                                </Card>

                                <Card className="mb-3">
                                    <CardBody>
                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                NO. OF EMPLOYEES
                                                <span className="asterisk_red">*</span>
                                            </Label>
                                            <select
                                                {...register("number_of_employees", disableValidation ? {} : { required: "Number of employees is required" })}
                                                className={`form-control ${errors.number_of_employees ? "form-invalid mb-0" : "mb-3"}`}
                                            >
                                                <option value="">Please select</option>
                                                {numberOfEmployees.map(
                                                    (type, index) => (
                                                        <>
                                                            <option
                                                                key={index}
                                                                value={type}
                                                            >
                                                                {type}
                                                            </option>
                                                        </>
                                                    ),
                                                )}
                                            </select>
                                            {errors.number_of_employees ? <p role="alert" className="invalid-feedback">{errors.number_of_employees.message}</p> : null}
                                        </>

                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                FINANCIAL TURNOVER
                                                <span className="asterisk_red">*</span>
                                            </Label>
                                            <select
                                                {...register("financial_turnover", disableValidation ? {} : { required: "Financial turnover is required" })}
                                                className={`form-control ${errors.financial_turnover ? "form-invalid mb-0" : "mb-3"}`}
                                            >
                                                <option value="">Please select</option>
                                                {financialTurnover(awardData.award_type.currency_sign).map(
                                                    (type, index) => (
                                                        <>
                                                            <option
                                                                key={index}
                                                                value={type}
                                                            >
                                                                {type}
                                                            </option>
                                                        </>
                                                    ),
                                                )}
                                            </select>
                                            {errors.financial_turnover ? <p role="alert" className="invalid-feedback">{errors.financial_turnover.message}</p> : null}
                                        </>

                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                INDUSTRY
                                                <span className="asterisk_red">*</span>
                                            </Label>
                                            <select
                                                {...register("industry", disableValidation ? {} : { required: "Industry is required" })}
                                                className={`form-control ${errors.industry ? "form-invalid mb-0" : "mb-3"}`}
                                            >
                                                <option value="">
                                                    Please select
                                                </option>
                                                {industries.map(
                                                    (industry, index) => (
                                                        <>
                                                            <option
                                                                key={index}
                                                                value={industry}
                                                            >
                                                                {industry}
                                                            </option>
                                                        </>
                                                    ),
                                                )}
                                            </select>
                                            {errors.industry ? <p role="alert" className="invalid-feedback">{errors.industry.message}</p> : null}
                                            {industryValue === 'Other (please specify below)' && (
                                                <>
                                                    <input
                                                        {...register("other_industry", disableValidation ? {} : { required: "Other Industry is required" })}
                                                        className={`form-control ${errors.other_industry ? "form-invalid mb-0" : "mb-3"}`}
                                                        type="text"
                                                        maxLength={255}
                                                    />
                                                    {errors.other_industry ? <p role="alert" className="invalid-feedback">{errors.other_industry.message}</p> : null}
                                                </>
                                            )}
                                        </>

                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                SUB MARKET
                                                <span className="asterisk_red">*</span>
                                            </Label>
                                            <p className="form-p mb-2">
                                                Please specify which sub-market your
                                                organisation operates in. E.g. if 'Food &
                                                Drink' is your industry, then 'Dairy
                                                Processor' may be your sub-market.
                                            </p>
                                            <input
                                                {...register("sub_market", disableValidation ? {} : { required: "Sub market is required" })}
                                                className={`form-control ${errors.sub_market ? "form-invalid mb-0" : "mb-3"}`}
                                                type="text"
                                                maxLength={255}
                                            />
                                            {errors.sub_market ? <p role="alert" className="invalid-feedback">{errors.sub_market.message}</p> : null}
                                        </>
                                    </CardBody>
                                </Card>

                                <Card className="mb-3">
                                    <CardBody>
                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                WHO ARE THE TOP SUPPLIERS / SERVICE
                                                PROVIDERS IN THIS AREA WHO CONTRIBUTED TO
                                                YOUR PROJECT / TEAM / COMPANY SUCCESS IN
                                                RELATION TO YOUR SUBMISSION? INSERT
                                                COMPANY NAME BELOW.
                                            </Label>
                                            <Row className="mb-2">
                                                <Col md="6" className="pr-1">
                                                    <input
                                                        {...register("supplier_1")}
                                                        className={`form-control`}
                                                        type="text"
                                                        maxLength={255}
                                                        placeholder="Supplier / Solution Provider #1"
                                                    />
                                                </Col>
                                                <Col md="6" className="pl-1">
                                                    <input
                                                        {...register("supplier_2")}
                                                        className={`form-control`}
                                                        type="text"
                                                        maxLength={255}
                                                        placeholder="Supplier / Solution Provider #2"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col md="6" className="pr-1">
                                                    <input
                                                        {...register("supplier_3")}
                                                        className={`form-control`}
                                                        type="text"
                                                        maxLength={255}
                                                        placeholder="Supplier / Solution Provider #3"
                                                    />
                                                </Col>
                                                <Col md="6" className="pl-1">
                                                    <input
                                                        {...register("supplier_4")}
                                                        className={`form-control`}
                                                        type="text"
                                                        maxLength={255}
                                                        placeholder="Supplier / Solution Provider #4"
                                                    />
                                                </Col>
                                            </Row>
                                        </>
                                    </CardBody>
                                </Card>

                                <Card>
                                    <CardBody>
                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                WEBSITE
                                                <span className="asterisk_red">*</span>
                                            </Label>
                                            <p className="form-p mb-2">
                                                Your organisation's website URL (in the
                                                format "http://www.example.com" or
                                                "https://www.example.com")
                                            </p>
                                            <input
                                                {...register("website_url", disableValidation ? {} : {
                                                    required: 'Website URL is required',
                                                    validate: value => {
                                                        // const urlPattern = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+)\.([a-zA-Z]{2,})(\/[a-zA-Z0-9-]*)*$/;
                                                        const urlPattern = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)$/;
                                                        return urlPattern.test(value) || "Website URL must be in the format 'http://www.example.com' or 'https://www.example.com'";
                                                    }
                                                })}
                                                className={`form-control ${errors.website_url ? "form-invalid mb-0" : "mb-3"}`}
                                                type="url"
                                                maxLength={255}
                                            />
                                            {errors.website_url ? <p role="alert" className="invalid-feedback">{errors.website_url.message}</p> : null}
                                        </>

                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                LINKEDIN
                                                <span className="asterisk_red">*</span>
                                            </Label>
                                            <p className="form-p mb-2">
                                                Your organisation's Linkedin URL.
                                            </p>
                                            <input
                                                {...register("linkedin_url", disableValidation ? {} : {
                                                    required: 'Linkedin URL is required',
                                                })}
                                                className={`form-control ${errors.linkedin_url ? "form-invalid mb-0" : "mb-3"}`}
                                                type="text"
                                                maxLength={255}
                                            />
                                            {errors.linkedin_url ? <p role="alert" className="invalid-feedback">{errors.linkedin_url.message}</p> : null}
                                        </>

                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                TWITTER
                                            </Label>
                                            <p className="form-p mb-2">
                                                Your organisation's Twitter URL.
                                            </p>
                                            <input
                                                {...register("twitter_url")}
                                                className={`form-control mb-3`}
                                                type="url"
                                                maxLength={255}
                                            />
                                        </>

                                        <>
                                            <Label className="award-subheader mb-2 font-weight-bold">
                                                FACEBOOK
                                            </Label>
                                            <p className="form-p mb-2">
                                                Your organisation's Facebook URL.
                                            </p>
                                            <input
                                                {...register("facebook_url")}
                                                className={`form-control mb-3`}
                                                type="url"
                                                maxLength={255}
                                            />
                                        </>
                                    </CardBody>
                                </Card>
                            </Col >
                        : null }
                        <Col md="4" className="text-left mt-3">
                            {currentPathName != "/entry-form/preview" ?
                                <button
                                    className="btn btn-outline-dark-prev"
                                    onClick={() => history.goBack()}
                                    style={{ width: '130px', fontSize: '14px' }}
                                    type='button'
                                >
                                    <strong>EXIT</strong>
                                </button>
                            : null }
                        </Col>
                        {(category.group == 'Rising Star' && candidateUnder5Years == 1) || (category.group == 'Sustainable Fit Out Project' && isSustainableFitOutProject == 1) || (category.group !== 'Rising Star' && category.group !== 'Sustainable Fit Out Project') || entry_id ?
                            <>
                                <Col md="8" className="text-right mt-3">
                                    {currentPathName == "/entry-form/preview" ?
                                        // <div className="bis-tooltip p-0" style={{ border: 'none', background: 'transparent' }}>
                                        //     <button
                                        //         className="btn btn-transparent text-dark"
                                        //         style={{ width: '180px', fontSize: '14px' }}
                                        //         type='button'
                                        //         disabled
                                        //     >
                                        //         <strong>SAVE FOR LATER</strong>
                                        //         <span className="bis-tooltiptext" style={{ width: '220px', marginLeft: '-107px' }}>This action is unavailable in this preview version</span>
                                        //     </button>
                                        // </div>
                                        null
                                    :data.status == '' || data.status == 'Draft' ? (
                                        <button
                                            className="btn btn-transparent text-dark"
                                            onClick={saveDraftSubmit}
                                            style={{ width: '180px', fontSize: '14px' }}
                                            type='button'
                                            disabled={draftStatus}
                                        >
                                            <strong>{!draftStatus ? 'SAVE FOR LATER' : 'SAVING...'}</strong>
                                        </button>
                                    ) : null}
                                    <button
                                        className="btn btn-blue-new"
                                        type="submit"
                                        style={{ width: '130px', fontSize: '14px' }}
                                    >
                                        <strong>NEXT PAGE</strong>
                                    </button>
                                </Col>
                            </>
                            :
                            <>
                                <Col md="8" className="text-right mt-3">
                                    {currentPathName == "/entry-form/preview" ?
                                        null
                                        : data.status == '' || data.status == 'Draft' ? (
                                            <button
                                                className="btn btn-transparent text-dark"
                                                style={{ width: '180px', fontSize: '14px' }}
                                                type='button'
                                                disabled
                                            >
                                                <strong>SAVE FOR LATER</strong>
                                            </button>
                                    ) : null}
                                    <button
                                        className="btn btn-blue-new"
                                        type="button"
                                        disabled
                                        style={{ width: '130px', fontSize: '14px' }}
                                    >
                                        <strong>NEXT PAGE</strong>
                                    </button>
                                </Col>
                            </>
                        }
                    </Row>
                : 
                    <Col lg="12">
                        <PageSpinner />
                    </Col>
                }
            </Form>
            <CategoryQuestionFileUploader
                show={showFileUploadModal}
                onHide={() => setShowFileUploadModal(false)}
                instance={uploadInstance}
                onData={handleChangeFile}
            />
            {currentPathName == "/entry-form/preview" ?
                <ToastContainer />
            : null }
        </Col >
    );
};

export default Details;